import { render } from "./SignUp.vue?vue&type=template&id=c5fc5aca"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import exportComponent from "/home/nata/programming/WebProjects/DjangoVueEcommerce/djackets_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__